import _en from "./locales/en";
var exports = {};
var __importDefault = exports && exports.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getErrorMap = exports.setErrorMap = exports.defaultErrorMap = void 0;
const en_1 = __importDefault(_en);
exports.defaultErrorMap = en_1.default;
let overrideErrorMap = en_1.default;
function setErrorMap(map) {
  overrideErrorMap = map;
}
exports.setErrorMap = setErrorMap;
function getErrorMap() {
  return overrideErrorMap;
}
exports.getErrorMap = getErrorMap;
export default exports;